import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./RoleForm.form";

const roleController = new Role();

export function RoleForm(props) {
  const { onClose, onReload, role } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(role),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
        };

        if (role) {
          await roleController.updateRole(role.id, data);
        } else {
          data.status = 1;
          await roleController.createRole(data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre de tipo de usuario"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {role ? "Actualizar tipo de usuario" : "Crear tipo de usuario"}
      </Form.Button>
    </Form>
  );
}